import ClickOutside from "vue-click-outside"
import { updatePersonalSettings } from "../store/personal-settings"

export default {
    directives: {
        ClickOutside
    },
    data() {
        return {
            isOpen: false,
            saveIsOpenKey: null
        }
    },
    /* mounted() {
        if (this.saveIsOpenKey && getPersonalSettings(this.saveIsOpenKey) !== null) {
            this.isOpen = getPersonalSettings(this.saveIsOpenKey)
        }
    },*/
    methods: {
        toggle() {
            if (!this.isOpen) {
                this.open()
            } else {
                this.hide()
            }
        },
        hide(event) {
            if (!this.isOpen) {
                return
            }

            if (event && event.target && this.allowedTargets) {
                for (const allowedTarget of this.allowedTargets) {
                    if (event.target.classList.contains(allowedTarget)) {
                        return
                    }
                }
            }

            this.isOpen = false

            if (this.onHide) {
                this.onHide()
            }

            if (this.saveIsOpenKey) {
                updatePersonalSettings(this.saveIsOpenKey, false)
            }
            this.$emit("setStatus", this.isOpen)
        },
        async open() {
            this.isOpen = true

            if (this.onOpen) {
                await this.onOpen()
            }

            if (this.saveIsOpenKey) {
                updatePersonalSettings(this.saveIsOpenKey, true)
            }

            this.$forceUpdate()
            this.$emit("setStatus", this.isOpen)
        }
    }
}
